import { render } from "./publishArticle.vue?vue&type=template&id=085ae0ea&scoped=true"
import script from "./publishArticle.vue?vue&type=script&lang=js"
export * from "./publishArticle.vue?vue&type=script&lang=js"

import "./css/antd.css?vue&type=style&index=0&lang=css"
import "./publishArticle.vue?vue&type=style&index=1&id=085ae0ea&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085ae0ea"]])

export default __exports__